import script from "./PoolTransferLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoolTransferLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PoolTransferLayout.vue?vue&type=style&index=0&id=7beab8c2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7beab8c2"]])

export default __exports__